import { URL, handleErrors } from "./depannageActions"

// Slice générique de notifications temps réel. `signalement` est le premier type
// d'événement ; d'autres viendront sans changer la structure.
export const NOTIF_WS_CONNECTING = "NOTIF_WS_CONNECTING"
export const NOTIF_WS_CONNECTED = "NOTIF_WS_CONNECTED"
export const NOTIF_WS_DISCONNECTED = "NOTIF_WS_DISCONNECTED"
export const NOTIF_SET_ITEMS = "NOTIF_SET_ITEMS"
export const NOTIF_RECEIVED = "NOTIF_RECEIVED"
export const NOTIF_MARK_ALL_READ = "NOTIF_MARK_ALL_READ"

// Compteur « non lus » suivi côté client : high-water-mark de l'id vu.
const LAST_SEEN_KEY = "signalement_last_seen"

export const getLastSeenId = () =>
	parseInt(localStorage.getItem(LAST_SEEN_KEY) || "0", 10)

export const setLastSeenId = (id) =>
	localStorage.setItem(LAST_SEEN_KEY, String(id))

export const wsConnecting = () => ({ type: NOTIF_WS_CONNECTING })
export const wsConnected = () => ({ type: NOTIF_WS_CONNECTED })
// `close` optionnel : { code, reason } de l'événement onclose (diagnostic prod).
export const wsDisconnected = (close) => ({
	type: NOTIF_WS_DISCONNECTED,
	payload: close || null,
})

export const setNotifItems = (items) => ({
	type: NOTIF_SET_ITEMS,
	payload: { items, lastSeenId: getLastSeenId() },
})

export const nouveauSignalementRecu = (data) => ({
	type: NOTIF_RECEIVED,
	payload: data,
})

export function markAllRead() {
	return (dispatch, getState) => {
		const { items } = getState().notificationInfo
		const maxId = items.reduce((m, it) => Math.max(m, it.id), 0)
		setLastSeenId(maxId)
		dispatch({ type: NOTIF_MARK_ALL_READ })
	}
}

// Re-fetch de rattrapage : recharge les signalements actifs après chaque
// (re)connexion WS, pour combler les messages manqués pendant une coupure.
export function fetchSignalements() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		const url = `${URL}api/informations?statut=actifs`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(setNotifItems(json)))
			.catch(() => {})
	}
}
